import { render, staticRenderFns } from "./ClientTierDisplayWidget.vue?vue&type=template&id=31a66456&scoped=true"
import script from "./ClientTierDisplayWidget.vue?vue&type=script&lang=js"
export * from "./ClientTierDisplayWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a66456",
  null
  
)

export default component.exports